import { useContext, useMemo } from "react";

import FileInput, { IFileInputComponentProps } from "components/FileInput/FileInput";
import { DynamicFormContext } from "containers/DynamicForm/DynamicFormContext";
import { IDynamicFormItemProps } from "containers/DynamicForm/DynamicFormItems";

export function DirectUploadInputItem({ item }: IDynamicFormItemProps<"inputDirectUpload">) {
  const { form } = useContext(DynamicFormContext);

  const { content, key } = item;
  const { attachable = [], disabled, multiple } = content;
  const { label, value } = form.getFormInput(key);

  const acceptableFiles = useMemo(() => {
    return attachable?.join(",");
  }, [attachable]);

  const handleFileInputChange: IFileInputComponentProps["onChange"] = event => {
    form.onChange({
      ...event,
      target: { ...event.target, id: key, files: event.files },
    });
  };

  return (
    <FileInput
      accept={acceptableFiles}
      dataTestId={key}
      disabled={disabled}
      id={key}
      label={label}
      multiple={multiple}
      onChange={handleFileInputChange}
      value={value}
    />
  );
}
